import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "col-xxl-12 mb-5 text-center" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "MG Pay History       ")
], -1)
const _hoisted_4 = {
  key: 0,
  type: "button",
  class: "btn btn-primary er fs-6 px-8 py-2",
  "data-bs-toggle": "modal",
  "data-bs-target": `#kt_modal_matchinpay_reload`
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Reload Now ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Enter OTP")
const _hoisted_7 = { class: "card-body py-3" }
const _hoisted_8 = { class: "col-xxl-3 py-5" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_11 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-125px rounded-start" }, "Ref. #"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-125px" }, "User ID"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-125px" }, "Amount"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Date"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-100px" }, "Author"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-100px" }, "Remarks"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-150px rounded-end" }, "Currency")
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("td", null, "PHP", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_matchinpay_process = _resolveComponent("matchinpay-process")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("img", {
        src: _ctx.matchinpayLogo,
        style: _ctx.logoStyle
      }, null, 12, ["src"])
    ]),
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card"]
    }, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        (!_ctx.isOverriden && _ctx.isAllowedMatchinPay == true)
          ? (_openBlock(), _createBlock("button", _hoisted_4, [
              (_ctx.hasPendingMatchinPayOTP == false)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _hoisted_5
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_6
                  ], 64))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_matchinpay_process, {
        ccode: _ctx.ccode,
        currency: _ctx.currency
      }, null, 8, ["ccode", "currency"]),
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode("a", {
            class: "btn btn-sm btn-danger me-3",
            style: _ctx.taggedTopUpAmount == 2000.00 ? 'background-color:#0000ab;' : 'background-color:#b80c50;'
          }, " MG Pay Balance: " + _toDisplayString(_ctx.numberWithCommas(Number(_ctx.matchinpaybalance).toFixed(2))) + " " + _toDisplayString(_ctx.currency), 5)
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("table", _hoisted_10, [
            _hoisted_11,
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                return (_openBlock(), _createBlock("tr", { key: index }, [
                  _createVNode("td", null, "   " + _toDisplayString(item.recid), 1),
                  _createVNode("td", null, _toDisplayString(item.usid), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.numberWithCommas(item.amount.toFixed(2))), 1),
                  _createVNode("td", null, _toDisplayString(item.dtestp), 1),
                  _createVNode("td", null, _toDisplayString(item.author), 1),
                  _createVNode("td", null, _toDisplayString(item.remarks), 1),
                  _hoisted_12
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ], 2), [
      [_vShow, !_ctx.loading && _ctx.localStorageCCODE === 0]
    ])
  ], 64))
}